{
  "enums": {
    "claimStatus": {
      "draft": "ड्राफ़्ट",
      "submitted": "जमा किया गया",
      "accepted": "स्वीकृत",
      "denied": "अस्वीकृत",
      "paid": "भुगतान किया गया"
    },
    "chargeStatus": {
      "pending": "लंबित",
      "unbilled": "बिल नहीं किया गया",
      "posted": "पोस्ट किया गया",
      "billed": "बिल किया गया",
      "adjusted": "समायोजित",
      "voided": "रद्द किया गया"
    },
    "statementDelivery": {
      "print": "प्रिंट",
      "email": "ईमेल",
      "both": "प्रिंट और ईमेल",
      "mail": "डाक"
    },
    "statementStatus": {
      "generated": "जनरेट किया गया",
      "sent": "भेजा गया",
      "viewed": "देखा गया"
    },
    "denialStatus": {
      "new": "नया",
      "inReview": "समीक्षाधीन",
      "appealing": "अपील की जा रही है",
      "resolved": "हल किया गया",
      "writtenOff": "बट्टे खाते में डाला गया"
    },
    "denialPriority": {
      "low": "निम्न",
      "medium": "मध्यम",
      "high": "उच्च"
    },
    "claimType": {
      "professional": "व्यावसायिक",
      "institutional": "संस्थागत",
      "dental": "दंत",
      "pharmacy": "फार्मेसी"
    },
    "paymentMethod": {
      "cash": "नकद",
      "check": "चेक",
      "creditCard": "क्रेडिट कार्ड",
      "debitCard": "डेबिट कार्ड",
      "bankTransfer": "बैंक हस्तांतरण",
      "digitalWallet": "डिजिटल वॉलेट",
      "insurance": "बीमा"
    },
    "paymentSource": {
      "patient": "रोगी",
      "insurance": "बीमा",
      "thirdParty": "तृतीय पक्ष"
    }
  },
  "form": {
    "validation": {
      "patientIdRequired": "रोगी आईडी आवश्यक है",
      "encounterIdRequired": "मुलाक़ात आईडी आवश्यक है",
      "payerIdRequired": "भुगतानकर्ता आईडी आवश्यक है",
      "chargeCodeRequired": "शुल्क कोड आवश्यक है",
      "unitPriceRequired": "इकाई मूल्य आवश्यक है",
      "amountRequired": "राशि आवश्यक है",
      "amountPositive": "राशि शून्य से अधिक होनी चाहिए",
      "chargeSelectionRequired": "कम से कम एक शुल्क चुनें"
    }
  },
  "pages": {
    "statements": {
      "title": "बिलिंग विवरण",
      "labels": {
        "dashboard": "डैशबोर्ड",
        "patient": "रोगी",
        "from": "से",
        "to": "तक",
        "batchGenerate": "बैच जनरेट करें",
        "previewStatement": "विवरण पूर्वावलोकन",
        "generatePrint": "जनरेट करें और प्रिंट करें",
        "generateEmail": "जनरेट करें और ईमेल करें",
        "printEmail": "प्रिंट और ईमेल",
        "print": "प्रिंट",
        "email": "ईमेल"
      },
      "placeholders": {
        "searchPatient": "नाम या MRN से खोजें..."
      },
      "aria": {
        "periodFrom": "विवरण अवधि से",
        "periodTo": "विवरण अवधि तक"
      },
      "table": {
        "header": {
          "statementHistory": "विवरण इतिहास",
          "patient": "रोगी",
          "mrn": "MRN",
          "date": "दिनांक",
          "amount": "राशि",
          "delivery": "वितरण",
          "status": "स्थिति"
        },
        "preview": {
          "modal": "विवरण पूर्वावलोकन",
          "patientStatement": "रोगी विवरण",
          "patient": "रोगी:",
          "mrn": "MRN:",
          "statementDate": "विवरण दिनांक:",
          "period": "अवधि:",
          "lineItemHeader": {
            "date": "दिनांक",
            "description": "विवरण",
            "charges": "शुल्क",
            "payments": "भुगतान",
            "balance": "शेष"
          },
          "openingBalance": "प्रारंभिक शेष",
          "totals": "कुल",
          "amountDue": "देय राशि"
        }
      },
      "states": {
        "generating": "जनरेट हो रहा है...",
        "loading": "पूर्वावलोकन जनरेट हो रहा है...",
        "noPatients": "कोई रोगी नहीं मिला",
        "noStatementData": "कोई विवरण डेटा उपलब्ध नहीं",
        "loadingHistory": "इतिहास लोड हो रहा है...",
        "noStatementsGenerated": "अभी तक कोई विवरण जनरेट नहीं हुआ",
        "selectedPatientId": "चयनित रोगी ID: {{id}}"
      },
      "toast": {
        "generated": "विवरण जनरेट हुआ",
        "generatedError": "विवरण जनरेट करने में विफल",
        "batchStarted": "बैच जनरेशन शुरू हुआ: {{count}} विवरण कतार में",
        "batchError": "बैच जनरेशन शुरू करने में विफल"
      }
    },
    "claims": {
      "title": "दावा प्रबंधन",
      "labels": {
        "dashboard": "डैशबोर्ड",
        "createClaim": "दावा बनाएँ",
        "filters": "फ़िल्टर",
        "submit": "जमा करें",
        "appeal": "अपील",
        "denialReason": "अस्वीकृति का कारण",
        "expandHint": "समर्पित दावा पृष्ठ में लाइन आइटम देखने के लिए दावा विस्तृत करें।",
        "cancel": "रद्द करें"
      },
      "filter": {
        "allStatuses": "सभी स्थितियाँ"
      },
      "placeholders": {
        "filterPayer": "भुगतानकर्ता द्वारा फ़िल्टर करें..."
      },
      "aria": {
        "claimDateFrom": "दावा तिथि से",
        "claimDateTo": "दावा तिथि तक"
      },
      "table": {
        "header": {
          "claimNumber": "दावा #",
          "patient": "रोगी",
          "payer": "भुगतानकर्ता",
          "total": "कुल",
          "status": "स्थिति",
          "submitted": "जमा किया गया",
          "actions": "क्रियाएँ"
        }
      },
      "modal": {
        "createClaim": "शुल्कों से दावा बनाएँ",
        "patientId": "रोगी ID *",
        "payerId": "भुगतानकर्ता ID *",
        "selectCharges": "शुल्क चुनें ({{selected}} चयनित)",
        "noBilledCharges": "इस रोगी के लिए कोई बिना बिल वाला शुल्क नहीं"
      },
      "states": {
        "loading": "दावे लोड हो रहे हैं...",
        "noClaims": "कोई दावा नहीं मिला",
        "creating": "बनाया जा रहा है..."
      },
      "toast": {
        "created": "दावा बनाया गया",
        "createdError": "दावा बनाने में विफल",
        "submitted": "दावा जमा किया गया",
        "submittedError": "दावा जमा करने में विफल",
        "resubmitted": "अपील के लिए दावा पुनः जमा किया गया",
        "resubmittedError": "दावा पुनः जमा करने में विफल",
        "patientPayerRequired": "रोगी और भुगतानकर्ता आवश्यक हैं",
        "chargeRequired": "कम से कम एक शुल्क चुनें"
      }
    },
    "charges": {
      "title": "शुल्क प्रबंधन",
      "labels": {
        "dashboard": "डैशबोर्ड",
        "newCharge": "नया शुल्क",
        "totalChargesPeriod": "कुल शुल्क (अवधि)",
        "filters": "फ़िल्टर",
        "cancel": "रद्द करें"
      },
      "filter": {
        "allStatuses": "सभी स्थितियाँ"
      },
      "placeholders": {
        "filterPatient": "रोगी द्वारा फ़िल्टर करें..."
      },
      "aria": {
        "serviceDateFrom": "सेवा तिथि से",
        "serviceDateTo": "सेवा तिथि तक"
      },
      "table": {
        "header": {
          "date": "तिथि",
          "patient": "रोगी",
          "encounter": "मुलाक़ात",
          "code": "कोड",
          "description": "विवरण",
          "qty": "मात्रा",
          "unitPrice": "इकाई मूल्य",
          "total": "कुल",
          "status": "स्थिति",
          "actions": "कार्रवाई"
        }
      },
      "actions": {
        "void": "रद्द करें"
      },
      "modal": {
        "voidCharge": "शुल्क रद्द करें",
        "voidChargeConfirm": "शुल्क {{code}} - {{description}} ({{amount}}) रद्द करें?",
        "reason": "कारण *",
        "reasonPlaceholder": "रद्द करने का कारण दर्ज करें..."
      },
      "states": {
        "loading": "शुल्क लोड हो रहे हैं...",
        "noCharges": "इस अवधि के लिए कोई शुल्क नहीं मिला",
        "voiding": "रद्द किया जा रहा है..."
      },
      "toast": {
        "voided": "शुल्क रद्द किया गया",
        "voidedError": "शुल्क रद्द करने में विफल",
        "reasonRequired": "कारण आवश्यक है"
      }
    },
    "payments": {
      "title": "भुगतान पोस्टिंग",
      "labels": {
        "dashboard": "डैशबोर्ड",
        "uploadEraEob": "ERA/EOB अपलोड करें",
        "postPayment": "भुगतान पोस्ट करें",
        "totalPaymentsPeriod": "कुल भुगतान (अवधि)",
        "filters": "फ़िल्टर",
        "cancel": "रद्द करें"
      },
      "placeholders": {
        "filterPatient": "रोगी के अनुसार फ़िल्टर करें..."
      },
      "aria": {
        "paymentDateFrom": "भुगतान दिनांक (से)",
        "paymentDateTo": "भुगतान दिनांक (तक)"
      },
      "table": {
        "header": {
          "date": "दिनांक",
          "patient": "रोगी",
          "claimNumber": "दावा #",
          "amount": "राशि",
          "method": "विधि",
          "reference": "संदर्भ",
          "postedBy": "पोस्ट किया गया"
        }
      },
      "modal": {
        "postPayment": "भुगतान पोस्ट करें",
        "patientId": "रोगी आईडी *",
        "claimId": "दावा आईडी (वैकल्पिक)",
        "claimIdHint": "अप्रयुक्त भुगतान के लिए खाली छोड़ें",
        "amount": "राशि *",
        "method": "विधि *",
        "referenceNumber": "संदर्भ संख्या",
        "referenceHint": "चेक संख्या, लेन-देन आईडी, आदि।",
        "notes": "नोट्स"
      },
      "states": {
        "loading": "भुगतान लोड हो रहे हैं...",
        "noPayments": "इस अवधि के लिए कोई भुगतान नहीं मिला",
        "posting": "पोस्ट हो रहा है..."
      },
      "toast": {
        "posted": "भुगतान सफलतापूर्वक पोस्ट किया गया",
        "postedError": "भुगतान पोस्ट करने में विफल",
        "patientAmountRequired": "रोगी और राशि आवश्यक हैं",
        "validAmount": "कृपया एक मान्य राशि दर्ज करें",
        "eraEobSoon": "ERA/EOB अपलोड जल्द ही आ रहा है"
      }
    },
    "chargeForm": {
      "title": "शुल्क बनाएँ",
      "labels": {
        "patientId": "रोगी आईडी *",
        "encounterId": "मुलाकात आईडी *",
        "chargeCode": "शुल्क कोड *",
        "description": "विवरण",
        "cptCode": "CPT कोड",
        "quantity": "मात्रा *",
        "unitPrice": "इकाई मूल्य *"
      },
      "placeholders": {
        "chargeCode": "शुल्क मास्टर खोजें...",
        "cptCode": "CPT प्रक्रिया कोड खोजें..."
      },
      "buttons": {
        "cancel": "रद्द करें",
        "create": "शुल्क बनाएँ"
      },
      "toast": {
        "created": "शुल्क बनाया गया",
        "createdError": "शुल्क बनाने में विफल"
      }
    },
    "claimForm": {
      "title": "दावा बनाएँ",
      "labels": {
        "patientId": "रोगी ID *",
        "encounterId": "मुलाकात आईडी *",
        "payerId": "भुगतानकर्ता ID *",
        "claimType": "दावा प्रकार *",
        "diagnosisCodes": "निदान कोड",
        "selectCharges": "शुल्क चुनें ({{selected}} चयनित)",
        "notes": "नोट्स"
      },
      "placeholders": {
        "diagnosisCodes": "अल्पविराम से अलग ICD-10 कोड (उदा. J06.9, R05)"
      },
      "buttons": {
        "cancel": "रद्द करें",
        "create": "दावा बनाएँ"
      },
      "toast": {
        "created": "दावा बनाया गया",
        "createdError": "दावा बनाने में विफल"
      }
    },
    "paymentForm": {
      "title": "भुगतान पोस्ट करें",
      "labels": {
        "patientId": "रोगी आईडी *",
        "claimId": "दावा आईडी",
        "amount": "राशि *",
        "method": "भुगतान विधि *",
        "source": "स्रोत",
        "referenceNumber": "संदर्भ संख्या",
        "notes": "नोट्स"
      },
      "placeholders": {
        "claimId": "वैकल्पिक — किसी दावे से जोड़ें",
        "reference": "लेन-देन या चेक संदर्भ"
      },
      "buttons": {
        "cancel": "रद्द करें",
        "post": "भुगतान पोस्ट करें"
      },
      "toast": {
        "recorded": "भुगतान दर्ज किया गया",
        "recordedError": "भुगतान दर्ज करने में विफल"
      }
    },
    "denials": {
      "title": "अस्वीकृति प्रबंधन",
      "subtitle": "बिलिंग दावा अस्वीकृतियों को ट्रैक और प्रबंधित करें",
      "placeholders": {
        "search": "दावे खोजें..."
      },
      "filter": {
        "all": "सभी"
      },
      "checkbox": {
        "assignedToMe": "मुझे सौंपा गया"
      },
      "table": {
        "header": {
          "claimNumber": "दावा संख्या",
          "patient": "रोगी",
          "denialCode": "अस्वीकृति कोड",
          "denialReason": "अस्वीकृति कारण",
          "amount": "राशि",
          "daysRemaining": "शेष दिन",
          "status": "स्थिति",
          "assignedTo": "सौंपा गया",
          "actions": "क्रियाएँ"
        }
      },
      "actions": {
        "review": "समीक्षा",
        "appeal": "अपील",
        "writeOff": "बट्टे खाते डालें",
        "cancel": "रद्द करें"
      },
      "modal": {
        "appealReason": "अपील कारण",
        "appealPlaceholder": "अपील का कारण बताएँ...",
        "submitAppeal": "अपील सबमिट करें",
        "writeOffTitle": "अस्वीकृति बट्टे खाते डालें",
        "writeOffConfirm": "क्या आप वाकई दावा {{claimNumber}} को {{amount}} के लिए बट्टे खाते डालना चाहते हैं? यह क्रिया पूर्ववत नहीं की जा सकती।",
        "writeOffButton": "बट्टे खाते डालें"
      },
      "states": {
        "loading": "अस्वीकृतियाँ लोड हो रही हैं...",
        "noDenials": "कोई अस्वीकृति नहीं मिली",
        "submitting": "सबमिट हो रहा है..."
      },
      "toast": {
        "updateError": "अस्वीकृति स्थिति अपडेट करने में विफल",
        "movedToReview": "दावा {{claimNumber}} समीक्षा में ले जाया गया",
        "appealSubmitted": "अपील सबमिट की गई",
        "writtenOff": "दावा {{claimNumber}} बट्टे खाते डाला गया"
      }
    }
  },
  "__review_denialReason": "Backend payer-authored — Phase 9, do not translate",
  "__review_denialCode": "Backend payer-authored — Phase 9, do not translate",
  "__review_chargeDescription": "Backend payer-authored — Phase 9, do not translate",
  "__review_chargeCode": "Backend payer-authored — Phase 9, do not translate"
}
